var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 41,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.5v40.1H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "M-13.6 0H67v40.1h-80.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    fillRule: "evenodd",
    d: "M-13.7 14h80.9v3.9h-81z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    fillRule: "evenodd",
    d: "M20.8 0h3.8v40.1h-3.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M24.5 0h3.8v40.1h-3.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M-13.7 17.8h80.9v3.9h-81z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-13.7 21.7h80.9v4h-81z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.3 0H32v40.1h-3.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e72910",
    d: "M16.1 20a10.7 10.7 0 1 0 21.5.1 10.7 10.7 0 0 0-21.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m26.3 10.7.4-1.2.4 1.2h1.3l-1 .8.5 1.4-1.2-.8-1.1.8.4-1.4-1-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m26.3 10.8.4-1 .3 1h1.2l-1 .7.5 1.2-1-.7-1 .7.4-1.2-1-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m26.5 11 .2-.7.2.7h.7l-.6.4.3.7-.6-.5-.6.4.3-.6-.6-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m34.6 16.6.4-1.3.4 1.3h1.4l-1 .8.4 1.4-1.2-.9-1.1.8.4-1.3-1-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m34.7 16.7.3-1.1.4 1h1.1l-.9.8.4 1.1-1-.7-1 .7.4-1.1-.9-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m34.8 16.8.2-.6.2.6h.7l-.5.4.2.7-.6-.4-.5.4.2-.7-.5-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m32.2 25.9.4-1.3.4 1.3h1.3l-1 .8.5 1.4-1.2-.9-1.1.8.4-1.3-1-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m32.2 26 .4-1.1.4 1h1l-.9.8.4 1.2-1-.8-1 .7.4-1.1-.9-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m32.4 26.1.2-.6.2.6h.7l-.6.4.3.7-.6-.4-.6.4.3-.7-.6-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m20.5 25.9.5-1.3.4 1.3h1.3l-1 .8.4 1.4-1.1-.9-1.2.8.5-1.3-1-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m20.6 26 .4-1.1.3 1h1.2l-1 .8.5 1.2-1-.8-1 .7.4-1.1-1-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m20.7 26.1.3-.6.2.6h.6l-.5.4.2.7-.5-.4-.6.4.2-.7-.5-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m18.4 16.3.4-1.2.4 1.2h1.4l-1 .9.4 1.3-1.2-.8-1.1.8.4-1.3-1-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m18.5 16.4.3-1 .4 1h1.1l-.9.7.4 1.2-1-.7-1 .7.4-1.2-.9-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m18.6 16.6.2-.6.2.6h.7l-.5.4.2.7-.6-.4-.5.4.2-.7-.5-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m32 13.6-.4 1.3-.4-1.2H30l1-.9-.4-1.3 1.1.8 1.2-.8-.5 1.3 1 .8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m32 13.6-.4 1-.3-1H30l1-.7-.5-1.2 1 .7 1-.7-.4 1.2 1 .7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m31.8 13.4-.2.6-.2-.6h-.6l.5-.4-.2-.7.5.4.6-.4-.2.7.5.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.4 22.7 35 24l-.4-1.2h-1.4l1-.9-.4-1.3 1.2.8 1.1-.8-.4 1.3 1 .8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m35.4 22.7-.4 1-.4-1h-1.1l.9-.7-.4-1.2 1 .7 1-.7-.4 1.2.9.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m35.2 22.5-.2.6-.2-.6H34l.5-.4-.2-.7.6.4.5-.4-.2.7.5.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m27.1 29.4-.4 1.3-.4-1.3h-1.4l1.1-.8-.5-1.4 1.2.9 1.1-.8-.4 1.3 1 .8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m27 29.3-.3 1.1-.4-1h-1.1l.9-.8-.4-1.2 1 .8 1-.7-.4 1.1.9.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m26.9 29.2-.2.6-.2-.6h-.7l.5-.5-.2-.6.6.4.6-.4-.3.6.5.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 22.7 19 24l-.4-1.2H17l1.1-.9-.5-1.3 1.2.8 1.1-.8-.4 1.3 1 .8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m19.3 22.7-.4 1-.4-1h-1.1l.9-.7-.4-1.2 1 .7 1-.7-.4 1.2.9.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m19.1 22.5-.2.6-.2-.6H18l.5-.4-.2-.7.6.4.6-.4-.3.7.6.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m22.2 13.8-.4 1.2-.4-1.2H20l1-.8-.4-1.4 1.2.8 1.1-.8-.4 1.4 1 .7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "m22.1 13.7-.3 1.1-.4-1h-1.1l.9-.8-.4-1.2 1 .8 1-.7-.4 1.1.9.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    fillRule: "evenodd",
    d: "m22 13.5-.2.7-.2-.7h-.7l.5-.4-.2-.7.6.5.5-.4-.2.6.5.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.5 25.2c.3 0 .5-1.4.5-2.9s-.2-2.8-.5-2.7-.6 1.3-.6 2.8q0 2.6.6 2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.2 25.1c.3 0 .6-1.3.6-2.8q0-2.6-.6-2.8c-.3 0-.6 1.4-.6 2.9s.3 2.8.6 2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 25.5c.2 0 .4-1.4.4-3.1s-.2-3-.5-3-.5 1.4-.5 3.1.2 3 .5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a95600",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.6 23c.5 0 .3-.2.5-.4q.5-.1.7.1 0 .4.2.4c.1 0 3.8-.2 4-.1v.5c-.2.1-4.8.3-5 .1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.2 24c0 .3.5.2.5.5s-1 0-1-.5 1-.8 1-.5-.5.2-.5.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.5 24c0 .3.5.2.6.5s-1 0-1-.5 1-.8 1-.5-.6.2-.6.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.8 24c0 .3.6.2.6.5s-1 0-1-.5 1-.8 1-.5c0 .2-.6.2-.6.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.2 24c0 .3.5.2.5.5s-1 0-1-.5 1-.8 1-.5c0 .2-.5.2-.5.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a95600",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.7 25q.3 0 .3-.3t-.3-.4q-.2 0-.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.8 24.7.2-.6q0-.7-.4-.6l-.2.6q0 .6.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 24.7q.3 0 .2-.7 0-.5-.3-.6t-.3.7q0 .5.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27 24 .2-.6q0-.5-.4-.6-.2 0-.2.7 0 .5.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 24q.3-.1.2-.8 0-.5-.3-.6t-.2.7q0 .7.3.6Zm.7 0 .2-.6q0-.6-.4-.7-.2 0-.2.7t.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.6 23.8q.3 0 .2-.7 0-.5-.3-.6t-.2.7q0 .5.3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.2 23.5q.2 0 .2-.7t-.4-.6q-.2 0-.2.7 0 .5.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.7 23.3q.3 0 .2-.7 0-.5-.3-.6t-.2.7q0 .5.3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#804bff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.3 16.7s-1 .8-.8 3 2.2 3.2 2.2 3.2.5-.6.4-2.4c-.2-2.6-1.1-3.7-1.1-3.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.3 24.8q.3 0 .4-.6 0-.6-.3-.7t-.3.6.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.9 24.7q.2 0 .3-.6t-.2-.7-.4.6.3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.6 24q.3 0 .4-.6 0-.5-.3-.6t-.3.6q0 .5.2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 24q.2 0 .3-.7t-.2-.7q-.2 0-.3.7 0 .5.2.7Zm.6.2q.3 0 .4-.7 0-.5-.3-.6t-.3.6q0 .5.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.3 23.9q.3 0 .3-.7 0-.5-.2-.6t-.3.6q0 .6.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m28 23.5.2-.7q0-.5-.2-.6t-.3.6q0 .6.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.5 23.2q.3 0 .4-.6 0-.6-.3-.7t-.3.6.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c90000",
    d: "M29.1 23q.7-.5-.1-2.6-1-2-1.7-2-.6.5.2 2.6.9 2 1.6 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.8 18.8q.2 0 .3-.3t-.3-.3-.4.3.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.9 18.4q.2 0 .3-.4l-.3-.3q-.3 0-.3.3t.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.4 18.3q.4 0 .4-.3l-.3-.3q-.3 0-.4.3 0 .3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.6 17.6q.3 0 .3-.2t-.3-.3-.3.3.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.6 17.3q.3 0 .3-.3t-.3-.3-.3.3.3.3Zm-.6.8q.4 0 .4-.3t-.3-.3-.4.3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.1 17.9q.3 0 .3-.3t-.3-.3q-.2 0-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.8 17.7q.3 0 .3-.3t-.3-.3-.4.3.4.3Zm.5-.9q.4 0 .4-.2t-.4-.3-.3.2.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.8 17.4q.3 0 .3-.3t-.3-.3q-.2 0-.3.3t.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.2 17.7q.2 0 .3-.3l-.3-.3q-.3 0-.3.3t.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m26.3 17.7.3-.3q0-.3-.3-.3t-.3.3q0 .2.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.4 17.4q.3 0 .3-.3t-.3-.3-.3.3.3.3Zm3 6.7c.5-.2.5-1.6-.1-3.2s-1.6-2.8-2.1-2.6-.5 1.6.1 3.2 1.5 2.8 2 2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.3 22.3v-.7q-.3-.6-.4-.5v.7q.3.6.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29 21.7c.8 1 .7 1.8.6 2.3-.3-.6-.4-1-1.2-2.2-.8-1-.4-1.8-.3-2.2 0 .3 0 1 .9 2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29 22.5c.8 1.2.7 1.8.6 2.4-.2-.7-.4-1-1.2-2.2-.8-1.1-.3-1.9-.3-2.3.1.4.1 1 1 2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29 23.2c1 1.1.8 1.8.7 2.4-.2-.7-.4-1-1.2-2.2-.8-1-.4-1.8-.4-2.2.2.3.2 1 1 2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.9 21.8q.3-.2 0-1.2-.6-1-.8-1-.3.2 0 1.2.4 1 .8 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.5 22.1q.3 0 0-1-.2-.7-.6-.8-.3.1 0 1 .4.9.6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 22.5q.3-.1 0-1t-.6-.8 0 1q.2.7.6.8Zm.3-1.8q.3 0 0-.7-.2-.5-.5-.6t0 .7q.3.7.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 21.1q.3 0 0-.7-.1-.6-.4-.7-.3.1 0 .7.1.6.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    fillRule: "evenodd",
    d: "M27.5 20q.5 1.2.2 1.3-.2 0-.6-1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.5 20q.5 1.2.2 1.3-.2 0-.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 20.3q.3 0 0-.7-.1-.6-.4-.6t0 .7q.1.7.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.6 20.6q.3 0 0-.7-.1-.6-.4-.7-.3.1 0 .7.1.6.4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    fillRule: "evenodd",
    d: "M27.2 19.1q.3.8.2 1l-.5-.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.2 19.1q.3.8.2 1l-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    fillRule: "evenodd",
    d: "M27.3 18.8q.4.8.3 1L27 19",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 18.8q.4.8.3 1L27 19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    fillRule: "evenodd",
    d: "M28 19q.6 1 .4 1.3l-.7-1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 19q.6 1 .4 1.3l-.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009200",
    fillRule: "evenodd",
    d: "m27.6 18.6.3 1q-.2 0-.6-.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.6 18.6.3 1q-.2 0-.6-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#804bff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 16.9v.5c.3.2 1.2 1 1.9.3-.6 0-1.6-1.2-2-.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#804bff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.8 16.4q-.1.4.2.6c.1 0 1.1 1 1.7.2-.5 0-1.5-1.2-1.9-.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#804bff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.7 16q-.2.3.1.5c.2.1 1.1 1 1.8.2-.5 0-1.6-1.1-2-.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#804bff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 15.4q-.1.4.2.6c.2.1 1.1 1 1.8.2-.6 0-1.6-1.1-2-.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#804bff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.9 15.2q.6-.4 1.3 0c.4.1 1 .9 1.5 1H28q-.5.4-1 .4-.9.1-1.3-.4-.1-.6.2-1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m26.8 15.7.3-.1q0-.2-.3-.2t-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26 16.4q.4 0 .4-.3-.1-.3-.5-.1-.3 0-.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.3 16.2V16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m26.5 15.8-.3.3q-.3 0-.5.6-.4-1 .2-1 .5-.3.6 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.5 16.5v-.2z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/dm.b604eadc03ae63324d5482baff9c4c47.svg";
export { ForwardRef as ReactComponent };